// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__22wIx","approved":"Status_approved__6sRQw","rejected":"Status_rejected__MKD9O","expired":"Status_expired__2c1ku","label":"Status_label__3Qyaj"};